// Third party libraries
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

// Components
import Loader from './components/loader';
import KeepAlive from './components/keepAlive';

// Routes
import CustomRoute from './routes';

// Locales
import I18n from '../i18n';

// Global styles
import GlobalStyle from './styled/global';
import { Spacer } from './styled/wrappers';

const App = () => {

    return (
        <I18nextProvider i18n={ I18n }>
            <BrowserRouter>
                <CustomRoute />
            </BrowserRouter>
            <GlobalStyle />
            <Loader open={ false } />
            <KeepAlive />
            <Spacer />
        </I18nextProvider>
    );

}

export default App;